<!-- 保单信息 -->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="起止日期">
        <a-date-picker :disabled-date="disabledDate" :disabled="disabledAll" :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="开始日期" v-decorator="['baodanData.startdata', { rules: [{ required: true, message: '请选择起始日期！' }] }]" @change="effectiveDateChange" />
        <a-date-picker :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" style="margin-left: 20px" disabled placeholder="结束日期" v-model="applicantInfoExpireDate" />
        <span style="margin-left: 24px" v-if="planOffsetDay > 0">共{{ planOffsetDay }}天</span>
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="投保企业名称">
        <a-input v-model="applicantInfo.name" :disabled="disabledAll" @change="e => handleChange(e.target.value, 'name')" v-decorator="['applicantInfo.name', { rules: [{ required: true, message: '请输入投保企业名称' }] }]" placeholder="请输入投保企业名称" @blur="queryCompanyCodeByName()"></a-input>
      </a-form-item>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件类型">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'idType')"
              v-decorator="[
                'applicantInfo.idType',
                {
                  rules: [{ required: true, message: '请选择投保企业证件类型' }]
                }
              ]"
              placeholder="请选择投保企业证件类型"
            >
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value"> {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
					<div class="idNumber-form-item">
						<a-form-item :label-col="{ span: 6 }" label="投保企业证件号码">
							<a-input
								@change="e => handleChange(e.target.value, 'idNumber')"
								:disabled="true"
								v-decorator="[
									'applicantInfo.idNumber',
									{
										rules: [
											{ required: true, message: '请输入投保企业证件号码' },
											{ validator: validateToNextPassword },
										]
									}
								]"
								placeholder="请输入投保企业证件号码"
							></a-input>
						</a-form-item>
						<!-- 客服二维码组件 -->
						<customerService></customerService>
					</div>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-form-item :label-col="{ span: 3 }" label="联系地址">
          <a-col :span="12">
            <a-cascader
              placeholder="请选择"
              :disabled="disabledAll"
              @change="(value, label) => handleChange(value, 'pacCode', label)"
              v-decorator="[
                'applicantInfo.pacCode',
                {
                  rules: [{ required: true, message: '请输入省市区' }]
                }
              ]"
              :options="addressOptions"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children'
              }"
              style="float: left; width: 250px"
            />
          </a-col>
          <a-col :span="12">
            <a-input
              :disabled="disabledAll"
              @change="e => handleChange(e.target.value, 'address')"
              v-decorator="[
                'applicantInfo.address',
                {
                  rules: [{ required: true, message: '请输入联系地址' }]
                }
              ]"
              placeholder="请输入联系地址"
              style="float: left; width: 350px; margin-left: 10px"
            >
            </a-input>
          </a-col>
        </a-form-item>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人姓名">
            <a-input
              @change="e => handleChange(e.target.value, 'contactsname')"
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.contactsname',
                {
                  rules: [{ required: true, message: '请输入联系人姓名' }]
                }
              ]"
              placeholder="请输入联系人姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人电话">
            <a-input
              @change="e => handleChange(e.target.value, 'contactsphone')"
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.contactsphone',
                {
                  rules: [
                    { required: true, message: '请输入联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' }
                  ]
                }
              ]"
              placeholder="请输入联系人电话"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人邮箱">
            <a-input
              @change="e => handleChange(e.target.value, 'email')"
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.email',
                {
                  rules: [
                    { required: true, message: '请输入联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }
                  ]
                }
              ]"
              placeholder="请输入联系人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="支付方式">
            <a-select
              @change="value => handleChange(value, 'payMethod')"
              @blur="value => $tools.yaJinTip(value)"
              style="width: 100%"
              placeholder="请选择支付类型"
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付类型' }]
                }
              ]"
            >
              <a-select-option v-for="item in payTypeList" :key="item.value" :value="item.value">{{ item.text }} </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <salInsuredTable :disabledAll="disabledAll" :columns="columns" :data="salInsuredList" :effectiveDate="applicantInfo.effectiveDate" @delSelect="delSelectpre" @addSelect="addSelectpre" @eduitSelect="eduitSelect"></salInsuredTable>
      <a-row :gutter="24">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="24" style="display: flex">
          <a-form-item style="width: 20%" label="保费" :label-col="{ span: 6 }">
            <a-input v-model="applicantInfo.totalPremium" disabled style="width: 130px" addonAfter="元" />
          </a-form-item>
          <a-form-item label="加费比例" :label-col="{ span: 8 }" style="width: 20%; margin-left: 30px">
            <a-input
              :disabled="disabledAll"
              v-decorator="[
                'premiumCalType',
                {
                  initialValue: '1',
                  rules: [
                    {
                      message: '请输入',
                      required: false
                    }
                  ]
                }
              ]"
              :min="1"
              @blur="addPremiumBlur"
            />
          </a-form-item>
          <a-form-item label="加费后总保费" :label-col="{ span: 12 }" style="width: 20%; margin-left: 30px">
            <a-input disabled addonAfter="元" v-model="applicantInfo.addTotalPrices" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled="!agreementAllRead" @change="onChangeyueduBtn" style="margin-bottom: 20px">
          投保人已充分阅读、理解并同意
          <fileView></fileView>
        </a-checkbox>
      </a-row>
      <a-row class="policy_none">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" :loading="submitLoad1" v-show="!disabledAll" @click="handleSubmit('save')">保存订单</a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="fastInsure">
              立即投保
            </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="goPolicy">
              编辑
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 支付的弹窗 -->
    <a-modal class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定" cancelText="关闭">
      <p
        style="
          text-align: center;
          font-size: 18px;
          margin-bottom: 0;
          padding: 20px;
          line-height: 30px;
        "
      >
        您投保的{{ productName() }}需支付保费 <span style="color: #fe8f2d; font-weight: bold"> {{ applicantInfo.addTotalPrices }} </span>&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import Vue from 'vue'
import moment from 'moment';
let DATA = require('../data').default;
import { policyMixin } from '@/mixins/policyMixin.js';
import { idNumberMixins } from '@/mixins/idNumberMixins.js';
import salInsuredTable from './salInsuredList';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    salInsuredTable
  },
  mixins: [policyMixin, idNumberMixins],
  data() {
    //这里存放数据
    return {
      calcTotalPrices: '', //加费保费
      premiumCalType: '', //加费比例
      formData: {}, //传递数据
      yueduBtn: false, //理解阅读
      saveBtnShow: false, //保存过
      submitLoad1: false, //保存中
      showPaySure: false, //支付
      postPolicyData: {}, //要提交的数据
      policyId: '', //支付回来的id
      checkVisible: false, //凭证支付
      showQrcodePayModal: false, // 二维码支付
      /**需要的数据开始 */
      applicantInfo: {
        name: '', //投保企业名称
        idType: '6', //证件类型
        idNumber: '', //证件号码
        enttypecode: '', //纳税人类型
        pacCode: '', //省市区
        address: '', //详细地址
        industrycode: [], //行业类别
        contactsname: '', //联系人名称
        contactsphone: '', //联系人电话
        email: '', // 邮箱
        remark: '', //备注
        payMethod: '', //支付类型
        totalPremium: 0, //总保费
        expireDate: '', //保单终止时间
        effectiveDate: '', //保单生效时间
        mon: 12 //保证期限
      },
      //表格的头部
      columns: DATA.columns,
      //表格的数据
      salInsuredList: [],
      rate: 0.2, //费率
      industrycodeTEXT: '', //四级行业的文本
      maxType: 1, //最大类别
      companyCode: '01', //企业性质
      perRiskInfo: '', //险种类
      evidenceNumber: '', //凭证号
      uniqueArr: [], //去重后的人数列表
      //投保人证件类型
      companyIdTypeOptions: DATA.companyIdTypeOptions,
      //发票类型
      invoiceprList: [
        {
          value: '01',
          text: '暂不开票'
        },
        {
          value: '03',
          text: '电子发票'
        }
      ],
      //投保的天数
      guarantPre: DATA.guarantPre,
      loading: false,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      RiskInfos: {
        riskInfos: [
          {
            riskCode: '1119201', //意外身故及伤残
            dutyCode: '1119201',
            amount: 100000,
            premiumAmt: 0,
            riskName: '意外身故、残疾',
            riskAmountDesc: 100000
          }
        ],
        salPolicy: {
          productCode: '', //产品code
          planCode: '',
          groupSize: 0, //人数
          creator: '', //用户id
          bracket: 12, //保费期限
          totalPremium: 0, //总保费
          addTotalPrices: 0 //加费保费
        },
        salPolicyExt: {
          isworkheightinvolved: 2
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          name: '', //被保人名称
          stature: 2 //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [] //人数
      }, //测算的数据
      modalVisible: false, //修改保费的弹窗
      resultPcontent: {},
      viewPcontent: {}, //展示的保费
      addPcontent: {}, //拷贝的
      creator: '1',
      productCode: '',
      plan: '',
      /**需要的数据结束 */
      guapre: 1,
      planOffsetDay: 0,
      baodanData: {
        startdata: ''
      },
      startValues: null,
      linshiContent: {},
      riskInfosAmount: {}, //计算险种的结果
      ZBAOFEI: 0, //原始保费
      addBAOFEI: 0, //修改添加的保费
      orderContent: {}, //订单的数据
      disabledAll: false, //是否是立即投保
      userParams: {
        userId: '',
        productCode: ''
      }
    };
  },
  //监听属性 类似于data概念
  computed: {
    applicantInfoExpireDate() {
      //生成投保截止日期
      let mon = this.applicantInfo.mon;
      let date = this.applicantInfo.effectiveDate;
      if (date && mon) {
        let t2 = moment(date)
          .add(mon, 'months')
          .subtract(1, 's');
        return t2;
      }
      return moment()
          .add(mon, 'months')
          .subtract(1, 's');
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    moment,
    productName() {
      return sessionStorage.getItem('productName')
    },
    goPolicy() {
      // 跳转编辑页面
      this.disabledAll = false;
      this.$bus.$emit('disabledBus', false);
      this.$router.push({
        name: 'tpnyty',
        query: {
          u: this.$route.query.u,
          p: this.$route.query.p,
          sign: this.$route.query.sign,
          planCode: this.$route.query.planCode
        }
      });
    },
    queryOrderDetails() {
      // 查询保单信息
      let parms = {
        policyId: this.$route.query.policyId
      };
      this.$api.queryOrderDetails(parms).then(res => {
        if (res.data.returnCode == 0) {
          if (res.data.content) {
            this.orderContent = res.data.content;
            if (res.data.content.salInsuredList) {
              //被保人清单
              this.salInsuredList = res.data.content.salInsuredList;
              this.salInsuredList.forEach((element, i) => {
                //处理投保人生日
                let str = element.birthDate;
                element.occupation = [element.occupationCode.substring(0, 2), element.occupationCode.substring(0, 4), element.occupationCode]; //职业类别代码
                element['index'] = i + 1;
                element.birthDate = str.slice(0, 4) + '-' + str.slice(4, 6) + '-' + str.slice(6, 8); //生日
              });
            }
            if (res.data.content.riskInfos) {
              // 险种信息
              let riskInfos = res.data.content;
              this.$bus.$emit('busRiskInfos', riskInfos);
            }
            if (res.data.content.salPolicyExt) {
              //险种扩展节点
              let salPolicyExt = res.data.content.salPolicyExt;
              this.$bus.$emit('busStature', salPolicyExt.isworkheightinvolved);
            }
            if (res.data.content.salPolicyHolderExt) {
              //投保信息扩展节点
              let salPolicyHolderExt = res.data.content.salPolicyHolderExt;
              this.industrycodeTEXT = salPolicyHolderExt.industryname;
            }
            if (res.data.content.salPolicy) {
              //投保信息节点  放入订单信息展示
              let salPolicy = res.data.content.salPolicy;
              this.policyId = salPolicy.id.toString();
              this.plan = salPolicy.planCode;
              this.applicantInfo.mon = parseInt(salPolicy.bracket); //保险期限月份
              this.applicantInfo.totalPremium = salPolicy.transactionTotalPremium;
              this.applicantInfo.addTotalPrices = salPolicy.totalPremium;
              this.applicantInfo.payMethod = salPolicy.payMethod;
              this.applicantInfo.remark = salPolicy.remark;
              this.creator = salPolicy.creator;
              this.productCode = salPolicy.productCode;
              this.applicantInfo.effectiveDate = moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss');
              this.applicantInfo.expireDate = moment(salPolicy.expireDate).format('YYYY-MM-DD HH:mm:ss');
              this.baodanData.startdata = this.applicantInfo.effectiveDate;
              this.form.setFieldsValue({
                //放入表单
                premiumCalType: salPolicy.discountfactor,
                applicantInfo: {
                  ...salPolicy,
                  effectiveDate: moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss')
                },
                baodanData: {
                  startdata: moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss')
                }
              });
            }
            if (res.data.content.salPolicyHolder) {
              let salPolicyHolder = res.data.content.salPolicyHolder;
              this.applicantInfo.name = salPolicyHolder.name;
              // filterPcode 整合地址code
              this.applicantInfo.pacCode = this.filterPcode([salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district] || []).arrCode;
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicyHolder,
                  // filterPcode 整合地址code
                  pacCode: this.filterPcode([salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district] || []).code
                }
              });
              this.applicantInfo.contactsname = salPolicyHolder.contactsname;
              this.applicantInfo.contactsphone = salPolicyHolder.contactsphone;
              this.applicantInfo.address = salPolicyHolder.address;
              this.applicantInfo.email = salPolicyHolder.email;
              this.applicantInfo.enttypecode = salPolicyHolder.enttypecode;
              this.applicantInfo.idNumber = salPolicyHolder.idNumber;
              this.applicantInfo.idType = salPolicyHolder.idType;
            }
            
            this.salInsuredList = res.data.content.salInsuredList;
            this.RiskInfos.premiumBaseDtoList = this.numResult(res.data.content.salInsuredList); //人员类别，处理成每一类的人数
            this.RiskInfos.salPolicy = { ...this.RiskInfos.salPolicy, ...res.data.content.salPolicy };
            this.RiskInfos.salPolicyHolder = { ...this.RiskInfos.salPolicyHolder, ...res.data.content.salPolicyHolder };
            this.RiskInfos.riskInfos = res.data.content.riskInfos; //险种信息
          }
        }
      });
    },
    filterPcode(arr) {
      // 遍历生成地址code
      let str;
      if (arr && arr.length) {
        if (isNaN(parseInt(arr[0]))) {
          str = 'text';
        } else {
          str = 'value';
        }
        if (!str) return;
        try {
          var addressOptions = this.$lodash.cloneDeep(this.addressOptions);
          var oneArr = addressOptions.filter(item => arr[0] == item[str]) || [];
          var twoArr = oneArr[0].children.filter(item => arr[1] == item[str]) || [];
          var threeArr = twoArr[0].children.filter(item => item[str] == arr[2]) || [];
        } catch (error) {
          throw new Error(error);
        }
        return {
          code: [oneArr[0] ? oneArr[0].value : '', twoArr[0] ? twoArr[0].value : '', threeArr[0] ? threeArr[0].value : ''],
          arrCode: [oneArr[0], twoArr[0], threeArr[0]]
        };
      }
    },
    //验证证件号码
    validateToNextPassword(rule, value, callback) {
      if (this.applicantInfo.idType=='04'){
        if (/(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/.test(value)) {
          callback();
        }else{
          callback(new Error("营业执照格式有误"), null);
        }
      }
      callback();
    },
    addPremiumBlur(value) {
      //加费逻辑
      this.RiskInfos.salPolicy.discountfactor = value;
      this.resultPremiumSum(this.RiskInfos);
    },
    resultPremiumSum(data) {
      //计算保费
      let copyData = this.$lodash.cloneDeep(data);
      let baodanData = this.form.getFieldValue('baodanData');
      let premiumCalType = this.form.getFieldValue('premiumCalType');
      let formData = {
        architecture: copyData.architecture,
        riskInfos: copyData.riskInfos, //险种信息 去除超龄
        // riskInfos: copyData.riskInfos.filter(item => item.nonDeductibleFlag != 1), //险种信息 去除超龄
        salPolicy: {
          effectiveDate: moment(baodanData.startdata).format('YYYY-MM-DD'), //startTime保单生效时间
          expireDate: moment(this.applicantInfoExpireDate).format('YYYY-MM-DD'), //endTime保单终止时间
          planCode: this.plan, //产品计划（固定值ConstructAccident）
          productCode: this.productCode, //productGroupCode产品组合代码（固定值ConstructAccident）
          creator: this.creator,
          discountfactor: premiumCalType, //折扣系数
          optionalFlag: 12 //保费期限
        },
        salPolicyHolder: {
          addfifty: '2',
          name: this.applicantInfo.name
        },
        salPolicyExt: copyData.salPolicyExt,
        salInsuredList: this.salInsuredList, //被保人列表
        premiumBaseDtoList: copyData.premiumBaseDtoList //人数
      };
      formData.salPolicyExt.occEmpVersion = this.fileCodeContent.id
      this.$api.calPremiumEmployer(formData).then(res => {
        //保费计算
        if (res.data.success) {
          let datas = res.data.content;
          this.applicantInfo.totalPremium = datas.originTotalPremium; //总保费
          this.applicantInfo.addTotalPrices = datas.totalPremium; //加费情况
          this.salInsuredList = datas.newSalInsuredList; //后端处理过的被保人  已放入保费
          this.RiskInfos.riskInfos = datas.newRiskInfos; //后端处理过的险种信息
        } else {
          this.$message.error(res.data.returnMsg + '错误');
        }
      });
    },
    effectiveDateChange(date1, date) {
      //处理时间的
      this.applicantInfo.effectiveDate = date;
      this.applicantInfo.expireDate = this.applicantInfoExpireDate;
    },
    disabledDate(current) {
      //开始时间 选择范围
      var dd = new Date();
      dd.setDate(dd.getDate() + 1); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      var time = y + '-' + m + '-' + d;
      var currents = moment(time);
      return current && current < currents;
    },
    handleSubmit(type) {
      //最后的提交
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.salInsuredList.length < 3) {
            this.$message.warning('最低投保人数3人');
            return;
          }
          let base = this.applicantInfo;
          let data = {
            salInsuredList: this.salInsuredList, //表格的数据
            salPolicy: {
              //保单信息
              planCode: this.productCode, //产品计划（固定值ConstructAccident）
              productCode: this.productCode, //productGroupCode产品组合代码（固定值ConstructAccident）
              creator: this.creator,
              id: this.policyId,
              discountfactor: values.premiumCalType, //折扣系数
              effectiveDate: moment(values.baodanData.startdata).format('YYYY-MM-DD'), //startTime保单生效时间
              expireDate: moment(this.applicantInfoExpireDate).format('YYYY-MM-DD'), //endTime保单终止时间
              payMethod: values.applicantInfo.payMethod, //支付类型”
              bracket: 12, //页面选择的保障期间（几个月就传几，整数）
              groupSize: this.salInsuredList.legnth || 0, //投保人数
              totalPremium: base.addTotalPrices, //totalPremium总保费
              transactionTotalPremium: base.totalPremium, //原始保费
              remark: values.applicantInfo.remark, //备注
              ordertraceno: '' //"凭证支付时的凭证号",
            },
            salPolicyHolderExt: {
              industryname: this.industrycodeTEXT
            },
            salPolicyExt: {
              isworkheightinvolved: this.RiskInfos.salPolicyHolder.stature, //是否高空作业
              occEmpVersion: this.fileCodeContent.id
            },
            salPolicyHolder: {
              type: 'C', //固定值
              addfifty: '2', // 测算类型
              //投保人信息
              enttypecode: values.applicantInfo.enttypecode, //纳税人类型
              name: values.applicantInfo.name, //name投保人名称
              idType: values.applicantInfo.idType, //证件类型
              idNumber: values.applicantInfo.idNumber, //certNo证件号码
              address: values.applicantInfo.address, //详细地址
              addresscode: `${base.pacCode[0].value}-${base.pacCode[1].value}-${base.pacCode[2].value}`,
              contactsname: values.applicantInfo.contactsname, //联系人姓名
              contactsphone: values.applicantInfo.contactsphone, //联系人电话
              email: values.applicantInfo.email, //联系人邮箱
              province: base.pacCode[0].text, //省
              city: base.pacCode[1].text, //市
              district: base.pacCode[2].text, //区
              stature: this.RiskInfos.salPolicyHolder.stature, //"是否高空，是：1，否：2，默认2"
              taxpayercertificateno: values.applicantInfo.idNumber //发票
            },
            riskInfos: this.RiskInfos.riskInfos.filter(item => item.amount > 0)
          };
          this.postPolicyData = data;
          if (this.$route.query.policyId) {
            this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
          }
          if (type == 'save') {
            this.submitLoad1 = true;
            this.axiosPolicy(); // 保存订单是 直接保存
          }
        } else {
          this.$message.error('请填写完整提交的数据');
        }
      });
    },
    axiosPolicy() {
      //提交保单

      this.$api
        .addPAPolicy(this.postPolicyData)
        .then(res => {
          if (res.data.returnCode == '00') {
            this.showPaySure = false;
            this.saveBtnShow = true;
            this.policyId = res.data.content;
            this.$message.success('保存成功！');
            this.$router.push({
              name: 'tpnyty',
              query: {
                u: this.$route.query.u,
                p: this.$route.query.p,
                sign: this.$route.query.sign,
                policyId: this.policyId,
                planCode: this.$route.query.planCode,
                continuation: '1'
              }
            });
            this.disabledAll = true;
            this.$bus.$emit('disabledBus', true);
          }
        })
        .finally(() => {
          this.submitLoad1 = false;
        });
    },
    paySure() {
      //支付确认
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
      this.$payModal({
        show: true,
        type: 'dybzxgz', //产品类型
        policyId: this.policyId, //产品id
        creator: this.creator, //用户id
        payMethod: this.applicantInfo.payMethod, //支付方式
        productCode: this.$route.query.p, //产品code
        totalPremium: this.applicantInfo.totalPremium, //支付总金额
        name: this.applicantInfo.name
      });
    },
    handleChange(value, type, label) {
      //监听输入框  塞值
      if (type == 'pacCode') {
        this.applicantInfo[type] = label;
      } else if (type == 'industrycode') {
        this.industrycodeTEXT = label ? label[2].text : '';
        this.applicantInfo[type] = value;
      } else {
        this.applicantInfo[type] = value;
      }
      if(type == 'idType') {
        this.queryCompanyCodeByName()
      }
    },
    queryCompanyCodeByName() {
      if(!this.applicantInfo.idType) {
        this.form.setFieldsValue({
          applicantInfo: {
            idNumber: ''
          }
        })
        this.applicantInfo.idNumber = ''
        return
      }
      this.queryCompanyIdNumber(this.applicantInfo.name, this.applicantInfo.idType, this.companyIdTypeOptions);
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$bus.$on('onRiskInfos', data => {
      // 从 试算组件中传出险种信息
      let strdata = this.$lodash.cloneDeep(data);
      this.RiskInfos.riskInfos = this.$lodash.cloneDeep(strdata.riskInfos);
      this.RiskInfos.salPolicy = strdata.salPolicy;
      this.RiskInfos.salPolicyHolder = strdata.salPolicyHolder;
      this.RiskInfos.salPolicyExt = strdata.salPolicyExt;
      if (this.salInsuredList.length > 0) {
        this.resultPremiumSum(this.RiskInfos);
      }
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    this.$bus.$off('onRiskInfos');
    this.$bus.$off('resultPcontent');
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.avatar-uploader >>> .ant-upload {
  width: 128px;
  height: 128px;
}

.avatar-uploader >>> .ant-upload img {
  width: 100%;
  height: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.btn_color {
  margin: 0 20px;
}
</style>
